import { CHECK_CUSTOMER_CODE_SUCCESS } from '../customer/types';
import {
  InvoiceActionTypes,
  InvoiceReducerType,
  INVOICE_INIT_STATE,
  INVOICE_FAILURE,
  RESET_FAILURE,
  RESET_SUCCESS,
  SEND_INVOICES_SUCCESS,
  RESET_ALL,
  IS_PROCESSING,
  CREATE_INVOICE_SUCCESS,
  VALIDATE_INVOICE_SUCCESS,
  PAYMENT_SUCCESS,
  CREATE_SUBSCRIPTION_SUCCESS,
  TOKEN_PAYMENT_SUCCESS,
  CLEAR_INVOICE_STATUS,
  UPDATE_INVOICE_SUCCESS,
} from './types';

export default function(
  state: InvoiceReducerType = INVOICE_INIT_STATE,
  action: InvoiceActionTypes,
): InvoiceReducerType {
  switch (action.type) {
    case IS_PROCESSING:
      return {
        ...state,
        isProcessing: true,
      };
    case UPDATE_INVOICE_SUCCESS:
      return {
        ...state,
        isFinished: true,
      };
    case SEND_INVOICES_SUCCESS:
      return {
        ...state,
        numSuccess: action.numSuccess,
        numFailure: action.numFailure,
        isProcessing: false,
        isFinished: true,
      };
    case CLEAR_INVOICE_STATUS:
      return {
        ...state,
        numSuccess: 0,
        numFailure: 0,
        isFinished: false,
      };
    case CREATE_INVOICE_SUCCESS:
    case TOKEN_PAYMENT_SUCCESS:
    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        isFinished: true,
      };
    case INVOICE_FAILURE:
      return {
        ...state,
        isProcessing: false,
      };
    case RESET_FAILURE:
      return {
        ...state,
        numFailure: INVOICE_INIT_STATE.numFailure,
        isProcessing: false,
      };
    case RESET_SUCCESS:
      return {
        ...state,
        numSuccess: INVOICE_INIT_STATE.numSuccess,
      };
    case CHECK_CUSTOMER_CODE_SUCCESS:
      return {
        ...state,
        isProcessing: false,
      };
    case VALIDATE_INVOICE_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
        status: action.status,
      };
    case PAYMENT_SUCCESS:
      return {
        ...state,
        isFinished: true,
      };
    case RESET_ALL:
      return INVOICE_INIT_STATE;
    default:
      return state;
  }
}
